import React, { Component } from 'react';
import { connect } from 'react-redux';
import Skeleton from 'react-loading-skeleton';

import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { filterErrorHandler } from '../../hoc/Shared/utility';
import Button from "../../components/Button/Button";
import { withNamespaces } from 'react-i18next';
import DomPurify from "../../components/Sanitize/DomPurify";

import { showAgentInbox } from "../../store/ducks/agentInbox/actions";

class AgentInboxShow extends Component {
    constructor(props){
        super(props);
        this.state = {
            loading: true,
            data: []
        }
    }

    componentDidMount() {
        const showInboxData = {};
        showInboxData.id = this.props.detailsParam.id;
        this.props.showAgentInbox(showInboxData);
    }

    shouldComponentUpdate(nextProps, nextState) {
        if(nextProps.show_agent_inbox !== undefined && nextProps.show_agent_inbox !== this.props.show_agent_inbox){
            if(nextProps.show_agent_inbox.data.responseCode === 200 && nextProps.show_agent_inbox.data.msgType === "success"){
                this.setState({
                    loading: false,
                    data: nextProps.show_agent_inbox.data.data.result
                });
            }
            else{
                this.setState({
                    loading: false,
                    data: []
                }, () => {
                    filterErrorHandler(nextProps.show_agent_inbox.data.message);
                });
            }
        }
        return true;
    }

    render() {
        const { t } = this.props;

        return (
            <Auxiliary>
                <div className="breadcrumb-header">
                    <div className="d-flex">
                        <div className="my-auto">
                            <Button
                                typeButton="button"
                                classValue="btn btn-back-outline"
                                idValue="back"
                                buttonName={<i className="angle fe fe-chevron-left"></i>}
                                clicked={() => this.props.changePageHandler("listing")}
                            />
                        </div>
                    </div>
                    <div className="my-auto">
                        <div className="d-flex">
                            <div className="content-title mb-0 my-auto">
                                <h4 className="content-title mb-0 my-auto ml-2">{t("agent-inbox.sub-page-title")}</h4>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row row-sm">
                    <div className="col-lg-12 col-xl-12 col-md-12 col-sm-12">
                        <div className="card  box-shadow-0">
                            <div className="card-header">
                                <h4 className="card-title mb-1">{t("agent-inbox.show-inbox")}</h4>
                            </div>

                            <div className="card-body pt-0">
                                {this.state.loading === true
                                    ? <Skeleton count={4} />
                                    : <table className="table table-bordered table-striped">
                                        <tbody>
                                            <tr>
                                                <th>{t("agent-inbox.title")}</th>
                                                <td field-key='title'>{this.state.data.title}</td>
                                            </tr>
                                            <tr>
                                                <th>{t("agent-inbox.content")}</th>
                                                <td><DomPurify text={this.state.data.content} className="text-center" /></td>
                                            </tr>
                                            <tr>
                                                <th>{t("agent-inbox.category")}</th>
                                                <td field-key='category'>{t(`inbox-type.${this.state.data.category}`)}</td>
                                            </tr>
                                            <tr>
                                                <th>{t("agent-inbox.date-range")}</th>
                                                <td field-key='date-range'>{(this.state.data.show_date) ? `${this.state.data.show_date}` : '-'}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </Auxiliary>
        );
    }
};

const mapStateToProps = state => {
    return {
        show_agent_inbox: state.agentInbox.show_agent_inbox
    }
};

const mapDispatchToProps = {
    showAgentInbox
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces('translation')(AgentInboxShow));